module.exports = __webpack_public_path__ + "img/produktbroschuren_be.d7b262dd.png";